import React from 'react';
import styled from 'styled-components';

interface LineNumbersProps {
  count: number;
}

let LineNumberContainer = styled.div`
  color: #aaa;
  text-align: right;
  user-select: none;
  padding-right: 1rem;
  padding-left: 0.5rem;
  background-color: black;
  border-right: 1px solid #222;
  padding-top: 11px;
  min-height: 100%;
  width: 60px;
`;

let Line = styled.div`
  height: 24px;
  line-height: 24px;
  font-size: 11px;
`;

let LineNumbers: React.FC<LineNumbersProps> = ({ count }) => {
  return (
    <LineNumberContainer>
      {Array.from({ length: count }).map((_, i) => (
        <Line key={i}>{i + 1}</Line>
      ))}
    </LineNumberContainer>
  );
};

export default LineNumbers;
